/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { Box, Button, CircularProgress, Icon, IconButton, LinearProgress, TextField, Tooltip } from '@mui/material';
import { colors } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
import Table from '../../../components/table/Table';
import { setAllGovNews } from '../../../redux/slices/posts/posts';
import { useLocation } from 'react-router-dom';
import { successNotify } from '../../../utils/helper';
import EditIcon from '@mui/icons-material/Edit';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import DeleteIcon from '@mui/icons-material/Delete';
import { setCompaniesList } from '../../../redux/slices/companies/companies';
import ReadMoreReact from "read-more-react"
import Editor from 'react-simple-wysiwyg';

const GovernanceNews = () => {

	const dispatch = useDispatch();
	const location = useLocation();

	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { govNews } = useSelector((state) => state?.posts);
	const { companiesList } = useSelector((state) => state?.companies);

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingDoc, setIsLoadingDoc] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);


	const [formData, setFormData] = useState({
		title: '',
		description: '',
		image: '',
		creator_id: '',
		creator_name: ''
	});
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});
	// let sendId = location.pathname === "/corporate-governance-library/legal-and-regulatory/posts" ? 1 : 2;


	const getNews = async (limit, page) => {
		setIsLoading(true)
		try {
			let params = {
				"type": "governance_news",
				"status": "true",
				"limit": limit || 10,
				"page": page || 1
			}
			await Api.post(`${endPoints?.news?.fetch}`, params, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllGovNews(
							response?.data?.data?.news?.news?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								title: d?.title,
								description: d?.description,
								type: d?.type,
								image: d?.image,
								url: d?.url,
								dt: d?.dt,
								creator_id: d?.creator_id,
								is_enabled: d?.is_enabled,
								creator_name: d?.creator_name,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.news?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};
	const getAllCompanies = async () => {

		setIsLoading(true)
		try {
			const response = await Api?.post(endPoints?.companies?.list, {
				"limit": 1000,
				"page": 1,
				"columns": "*",
				"sortby": "ASC",
				"orderby": "id",
				"where": "id ^!= ^$1 AND displayed = false order by id",
				"values": 0
			}, {
				headers: {
					'xt-user-token': null
				}
			});
			dispatch(
				setCompaniesList(
					response?.data?.data?.clients?.clients?.map((d, index) => ({
						id: d?.id,
						description: d?.company_name,
					})
					),
				),
			);
			setIsLoading(false)

		} catch (error) {

		}
	};


	const handleCloseModal = () => {
		setOpenModal(false)
		setFormData({ title: '', url: '', description: '', image: '', creator_id: '', creator_name: '' })
		setIsEditing(false)

	};
	const handleCloseDeleteModal = () => {
		setFormData({ title: '', url: '', description: '', image: '', creator_id: '', creator_name: '' })
		setOpenDeleteModal(false)
	};

	const handleEditModal = (val) => {
		setOpenModal(val)
		setFormData({ id: val.id, title: val.title, url: val.url, description: val.description, image: val.image, creator_id: val.creator_id, creator_name: val.creator_name })
		setIsEditing(true)
	};

	const handleOpenDeleteModal = (val) => {
		setFormData({ id: val.id })
		setOpenDeleteModal(true)
	};

	const handleChange = (e) => {
		if (e.target.name === "creator_id") {
			const matchingCompany = companiesList.find(company => company.id === e.target.value);
			if (matchingCompany) {
				setFormData((prevState) => ({
					...prevState,
					creator_name: matchingCompany.description,
				}))
			}
		}
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};


	const handleImageUpload = (event) => {
		setIsLoadingImg(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false)
					setFormData((prevState) => ({
						...prevState,
						image: response.data.data.link,
					}));
					successNotify("Image Uploaded Successfully")

				})
				.catch((error) => {
					// if (error?.response?.status === 400) {
					// 	errorNotify(error?.response?.data);
					// 	setDisabledBtn(false);
					// }
					// setErrMsg(error?.response?.data?.message || errorMsg);
				});

			// setErrMsg('Login Failed');

		}
	};


	const handleSubmit = async () => {
		setIsLoadingModal(true)
		if (!isEditing) {

			try {

				const data = {
					...formData,
					"type": "governance_news",
					"is_enabled": "false", // true or false

				};

				await Api.post(endPoints?.news?.create, data, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						successNotify("News Created Successfully")
						getNews();
						setIsLoadingModal(false)
					})
					.catch((error) => {

					});
			} catch (err) {
			}

		} else {

			try {

				const data = {
					...formData,
					"type": "governance_news",
					"is_enabled": "false", // true or false
				};

				await Api.post(endPoints?.news?.update, data, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						successNotify("News Updated Successfully")
						getNews();
						setIsLoadingModal(false)
					})
					.catch((error) => {

					});
			} catch (err) {
			}


		}
	};

	const handleDelete = async () => {
		try {

			await Api.post(endPoints?.news?.delete, {
				...formData
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					handleCloseDeleteModal();
					successNotify("News Deleted Successfully")
					getNews();

				})
				.catch((error) => {

				});

		} catch (err) {
		}
	};

	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'Title',
			field: 'title',
			render:  (rowData) => <h4 className='font-face-R'>{
				rowData?.title?.length > 15 ?
					<ReadMoreReact
						text={rowData?.title}
						min={10}
						ideal={15}
						max={rowData?.title?.length}
						readMoreText="Read More"
					/> : rowData?.title}</h4>,
		},
		{
			title: 'Description',
			field: 'description',
			width: "10%",
			render: (rowData) => <h4 className='font-face-R'>{rowData?.description?.length > 80 ?
				<ReadMoreReact
					text={rowData?.description}
					min={50}
					ideal={80}
					max={rowData?.description?.length}
					readMoreText="Read More"
				/> : rowData?.description}</h4>,
		},
		// {
		// 	title: 'Date',
		// 	field: 'dt',
		// 	render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format('DD-MM-YYYY')}</h4>,
		// },
		{
			title: 'Status',
			field: 'is_enabled',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.is_enabled ? <Icon color='success' className="text-green text-16">check_circle</Icon> : <Icon className="text-red text-16">cancel</Icon>}</h4>,
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Delete',
			field: 'delete',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Delete'>
					<IconButton onClick={() => handleOpenDeleteModal(rowData)} aria-label='Delete'>
						<DeleteIcon />
					</IconButton>
				</Tooltip>
			),
		},

	];

	useEffect(() => {
		getNews()
		getAllCompanies()
	}, [])

	return (
		<>
			<Card margin='3rem 1.5rem' padding='3rem'>
				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom btnTitle='Add News' onClickHandler={() => setOpenModal(true)} />

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Update News" : 'Add News'}
						isLoading={isLoadingModal}
					// submitHandler={leaveApprovedHandler}
					// submitDisabledBtn={leaveApprovedDis}
					>
						<Grid gtc='repeat(auto-fit, minmax(35rem, 1fr))' margin='2.5rem 0' padding='2rem'>

							{/* <MarginHandler width='100%'> */}
							<InputControl
								state={formData?.title}
								onChange={handleChange}
								// inputProps={{ maxLength: 150 }}
								label='Title'
								name='title'
							/>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.description}
									onChange={handleChange}
									// inputProps={{ maxLength: 250 }}
									label='Description'
									name='description'
									required
								/>
							</MarginHandler>
							<InputControl
								state={formData?.url}
								onChange={handleChange}
								label='Url'
								name='url'
							/>
							{/* </MarginHandler> */}
							{/* <MarginHandler width='100%'> */}
							{/* <InputControl
								state={formData?.description}
								onChange={handleChange}
								label='Description'
								name='description'
								multiline
								rows={1}
							/> */}
							{/* <Editor value={formData?.description} name='description' onChange={handleChange} /> */}
							{/* </MarginHandler> */}
							<FilledSelectOption
								label='Created By'
								initalStateNotShow
								state={formData.creator_id}
								onChange={handleChange}
								options={companiesList}
								maxWidth='100%'
								minWidth='100%'
								width='100%'
								name='creator_id'
							/>


							{isLoadingImg ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept=".jpeg, .jpg, .png"
										style={{ display: 'none' }}
										id="image-upload"
										type="file"
										onChange={(event) => handleImageUpload(event)}
									/>
									<label htmlFor="image-upload">
										<Button
											variant="contained"
											component="span"
											fullWidth
											color='success'
											style={{ fontSize: '1em' }}
										>
											Upload Image
										</Button>
									</label>
									{formData?.image &&
										<img height={200} style={{ margin: "auto" }} src={formData?.image} />
									}
								</>}
							{/* <MarginHandler width='50%'> */}




						</Grid>
						<MarginHandler mt="2rem">
							<Button
								color='primary'
								variant='contained'
								onClick={handleSubmit}
								style={{
									background: colorGreenGradient,
									fontSize: '1.6rem',
									textTransform: 'none',
									padding: '0.7rem 2rem',
									margin: "0 1em 1em 0",
									color: colorWhite,
									borderRadius: '0.5rem',
									float: "right"
								}}
								className='font-face-R'
								disabled={!formData.image || !formData.title || !formData.creator_id}>

								{isEditing ? "Update News" : 'Add News'}
							</Button>
						</MarginHandler>
					</TransitionsModal>


				</Flex>
				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={govNews?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="General News"
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getNews(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getNews(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}

				<DeleteModal
					open={openDeleteModal}
					handleClose={handleCloseDeleteModal}
					handleDelete={handleDelete}
				/>
			</Card>
		</>
	);
};

export default GovernanceNews;
